export function isClearedFieldValue(value) {
  return value == null || value === "";
}

export function numericValuesMatch(a, b) {
  if (isClearedFieldValue(a) && isClearedFieldValue(b)) return true;
  if (isClearedFieldValue(a) || isClearedFieldValue(b)) return false;
  return Number(a) === Number(b);
}

export function isNumericOverride(current, fallback) {
  if (isClearedFieldValue(fallback)) return false;
  if (isClearedFieldValue(current)) return false;
  return Number(current) !== Number(fallback);
}

export function stressTestFieldDefaults(countyData) {
  return {
    yield_low: countyData?.yield_low,
    yield_high: countyData?.yield_high,
    price_low: countyData?.price_low,
    price_high: countyData?.price_high,
    county_yield_low: countyData?.county_yield_low,
    county_yield_high: countyData?.county_yield_high,
  };
}
